<template>
      <div class="btn-render-plus">
        <template v-if="option.btnType=='create'" >
          <button class="button-action-head button-action-head--create" @click="actionToLink(option)">
            <i class="item_icon material-icons">add</i>
          </button>
        </template>
        <template v-else-if="option.btnType=='download'">
          <button class="button-action-head button-action-head" @click="actionToLink(option,'dowload')" :style="{backgroundColor: headerColor}">
            <i class="item_icon material-icons space-icon">vertical_align_bottom</i>
          </button>
        </template>
      </div>
      
    </template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "HeadaButton",
  props: {
    option: {
      type: Object,
      default() {
        return {
          btnAction: Boolean,
          valueBtn: String,
          ruta: String,
          btnType: String
        };
      }
    }
  },
  computed: {
    ...mapGetters(["headerColor"])
  },
  methods: {
    actionToLink: function(op, type) {
      if (type == "dowload") {
        return window.open(op.ruta, "_blank");
      }
      this.$router.push(`${op.ruta}`);
    }
  }
};
</script>

<style lang="scss">
.btn-render-plus {
  a {
    color: white !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Componentes/headButton.vue